import React from "react";
import Popup from "../Popup/Popup.jsx";
import "./SchoolDetailsPopup.css";

const SchoolDetailsPopup = ({ school, isVisible, onClose }) => {
  if (!school) return null;

  const renderBasicDetails = () => {
    const basicFields = [
      { label: "School ID", value: school.school_id },
      { label: "School Name", value: school.school_name },
      { label: "UDISE Code", value: school.udise_code },
      { label: "School Type", value: school.school_type },
      { label: "Board", value: school.board },
      { label: "Branch Name", value: school.branch_name },
      { label: "Address", value: school.address },
      { label: "City", value: school.city },
      { label: "State", value: school.state },
      { label: "Country", value: school.country },
      { label: "Pincode", value: school.pincode },
      {
        label: "Phone",
        value: school.phone ? `${school.isd_code} ${school.phone}` : "N/A",
      },
      { label: "Email", value: school.email },
      { label: "Activation Code", value: school.activation_code },
      { label: "Fee", value: school.fee },
      { label: "Tier", value: school.tier },
      { label: "Category", value: school.category },
    ];

    return (
      <div className="school-details-section">
        <h3 className="section-title">Basic Details</h3>
        <div className="details-grid">
          {basicFields.map((field, index) => (
            <div key={index} className="detail-item">
              <label>{field.label}</label>
              <span>{field.value || "N/A"}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderContactDetails = () => {
    const renderContactInfo = (contact, title) => {
      if (!contact) return null;

      return (
        <div className="contact-info-section">
          <h4>{title}</h4>
          <div className="details-grid">
            <div className="detail-item">
              <label>Name</label>
              <span>{contact.name || "N/A"}</span>
            </div>
            <div className="detail-item">
              <label>Phone</label>
              <span>
                {contact.phone ? `${contact.isd_code} ${contact.phone}` : "N/A"}
              </span>
            </div>
            <div className="detail-item">
              <label>Email</label>
              <span>{contact.email || "N/A"}</span>
            </div>
            {contact.designation && (
              <div className="detail-item">
                <label>Designation</label>
                <span>{contact.designation}</span>
              </div>
            )}
          </div>
        </div>
      );
    };

    return (
      <div className="school-details-section">
        <h3 className="section-title">Contact Details</h3>
        {renderContactInfo(school.primary_contact_info, "Primary Contact")}
        {renderContactInfo(school.secondary_contact_info, "Secondary Contact")}
      </div>
    );
  };

  const renderHeadcount = () => {
    const totalCounts = [
      { label: "Total Students", value: school.total_student_count },
      { label: "Total Teachers", value: school.total_teacher_count },
      { label: "Other Staff", value: school.other_staff_count },
    ];

    const formatGradeLabel = (key) => {
      if (key === "lkg") return "LKG";
      if (key === "ukg") return "UKG";
      return key
        .split("_")
        .map((word) => (word === "grade" ? "Grade" : word))
        .join(" ");
    };

    return (
      <div className="school-details-section">
        <h3 className="section-title">School Headcount</h3>
        <div className="details-grid">
          {totalCounts.map((count, index) => (
            <div key={index} className="detail-item">
              <label>{count.label}</label>
              <span>{count.value || 0}</span>
            </div>
          ))}
        </div>
        <h4>Grade-wise Student Count</h4>
        <div className="grade-count-grid">
          {school.grade_wise_count &&
            Object.entries(school.grade_wise_count).map(([grade, count]) => (
              <div key={grade} className="grade-count-item">
                <label>{formatGradeLabel(grade)}</label>
                <span>{count || 0}</span>
              </div>
            ))}
        </div>
      </div>
    );
  };

  return (
    <Popup
      isVisible={isVisible}
      onClose={onClose}
      title="School Details"
      contentClassName="school-details-popup__content"
    >
      <div className="school-details-popup__body">
        {renderBasicDetails()}
        {renderContactDetails()}
        {renderHeadcount()}
      </div>
    </Popup>
  );
};

export default SchoolDetailsPopup;
